import { render, staticRenderFns } from "./vehicle-detail.vue?vue&type=template&id=bae3a7f8&scoped=true&"
import script from "./vehicle-detail.vue?vue&type=script&lang=ts&"
export * from "./vehicle-detail.vue?vue&type=script&lang=ts&"
import style0 from "@/modules/AccountAsset/styles/vehicle-detail-detail.scss?vue&type=style&index=0&id=bae3a7f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae3a7f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
